// @flow
import type { InternshipFunctions } from 'api/orgs';
import type { Action } from '../actions/internshipFunctions';

export type State = ?InternshipFunctions;

export default function internshipFunctions(
  state: State = null,
  action: Action
) {
  switch (action.type) {
    case 'INTERNSHIP_FUNCTIONS_SET': {
      return action.internshipFunctions;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
